import { useState, useRef, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import YouTubeIcon from "@mui/icons-material/YouTube";
import ProductImage from "../../assets/images/checkout/product-Image.png";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
/* ==== ICON IMPORTS (same as yours) ==== */
// Thickness icons
import Icon6Active from "../../assets/icons/green_6in.png";
import Icon6Inactive from "../../assets/icons/02.png";
import Icon8Active from "../../assets/icons/green_8in.png";
import Icon8Inactive from "../../assets/icons/04.png";
import Icon10Active from "../../assets/icons/green_10in.png";
import Icon10Inactive from "../../assets/icons/06.png";

// Size icons
import IconSingleActive from "../../assets/icons/green_single.png";
import IconSingleInActive from "../../assets/icons/08.png";
import IconQueenActive from "../../assets/icons/green_queen.png";
import IconQueenInactive from "../../assets/icons/10.png";
import IconKingActive from "../../assets/icons/green_king.png";
import IconKingInactive from "../../assets/icons/12.png";

// Custom size icons
import CustomSizeActive from "../../assets/icons/gren_custom.png";
import CustomSizeInActive from "../../assets/icons/14.png";

export default function OptionsOffcanvas({
  isOpen,
  onClose,
  selected,
  setSelected,
}) {
  /* ================= STATES ================= */
  const [customSizeActive, setCustomSizeActive] = useState(false);
  const [tempSelected, setTempSelected] = useState(selected);
  const [customDropdownOpen, setCustomDropdownOpen] = useState(false);
  const [coverDropdownOpen, setCoverDropdownOpen] = useState(false);

  const [selectedCover, setSelectedCover] = useState({
    value: "aloe",
    label: "Aloe vera cover",
    description: "Natural Aloe vera Infused Fiber",
  });

  const dimensionRef = useRef(null);
  const coverRef = useRef(null);

  /* ================= DATA ================= */
  const thicknessOptions = [
    {
      label: "6 Inch",
      value: "6",
      activeIcon: Icon6Active,
      inactiveIcon: Icon6Inactive,
    },
    {
      label: "8 Inch",
      value: "8",
      activeIcon: Icon8Active,
      inactiveIcon: Icon8Inactive,
    },
    {
      label: "10 Inch",
      value: "10",
      activeIcon: Icon10Active,
      inactiveIcon: Icon10Inactive,
    },
  ];

  const SizeOptions = [
    {
      label: "Single",
      value: "Single",
      activeIcon: IconSingleActive,
      inactiveIcon: IconSingleInActive,
    },
    {
      label: "Queen",
      value: "Queen",
      activeIcon: IconQueenActive,
      inactiveIcon: IconQueenInactive,
    },
    {
      label: "King",
      value: "King",
      activeIcon: IconKingActive,
      inactiveIcon: IconKingInactive,
    },
  ];

  const dimensionOptions = [
    { value: "72x72", labelInch: "72x72 Inch", labelCm: "(182x182 cm)" },
    { value: "75x60", labelInch: "75x60 Inch", labelCm: "(190x152 cm)" },
    { value: "78x72", labelInch: "78x72 Inch", labelCm: "(198x182 cm)" },
  ];

  const coverOptions = [
    {
      value: "aloe",
      label: "Aloe vera cover",
      description: "Natural Aloe vera Infused Fiber",
    },
    {
      value: "organic",
      label: "Organic Cotton Cover",
      description: "100% Eco-friendly Cotton Finish",
    },
  ];
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // cleanup (important)
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      setTempSelected(selected); // reset draft when opened
    }
  }, [isOpen, selected]);
  const containerRef = useRef(null);
  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };
  return (
    <>
      {/* BACKDROP */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-[#113b1880] backdrop-blur-sm z-40"
          onClick={onClose}
        />
      )}

      {/* SIDE DRAWER */}
      <div
        className={`fixed top-0 right-0 z-50 h-full 2xl:w-[45%] xl:w-[50%] lg:w-[70%]  w-full bg-white
        transition-transform duration-300 ease-in-out
        ${isOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        <div className="h-full flex flex-col font-lexend">
          {/* HEADER */}
          <div className=" flex justify-between items-start px-5 md:px-10 3xl:px-20 pt-8">
            <div></div>
            <CloseIcon
              onClick={onClose}
              className="w-5 h-5 flex items-center justify-center rounded-full border border-[#29562f] text-[#29562f]"
            />
          </div>

          {/* CONTENT */}
          <div
            ref={containerRef}
            className="flex-1 overflow-y-auto px-5 md:px-10 3xl:px-20 pb-32"
          >
            <div className="flex gap-8 mb-3 items-end ">
              <img
                src={ProductImage}
                alt=""
                className="md:w-auto md:h-auto w-32 h-32 "
              />
              <h2 className="text-[24px] md:text-[28px] xl:text-[42px] 3xl:text-[52px] leading-[1.4em] font-calsans  md:leading-[42px] 3xl:leading-[54px]">
                Ortho <br />
                Latex Mattress
              </h2>
            </div>
            {/* THICKNESS */}
            <p className="font-semibold font-lexend text-[18px] md:text-[20px] py-3 ">
              Select thickness
            </p>
            <div className="grid grid-cols-3 gap-4">
              {thicknessOptions.map((opt) => {
                const active = tempSelected.thicknessValue === opt.value;
                return (
                  <div
                    key={opt.value}
                    onClick={() =>
                      setTempSelected((prev) => ({
                        ...prev,
                        thicknessValue: opt.value,
                        thicknessUnit: "Inch",
                      }))
                    }
                    className={`cursor-pointer flex flex-col md:flex-row gap-2 sm:gap-3
          items-center justify-center p-3 rounded-lg border
          ${active ? "bg-[#deecdd]" : "border-gray-300"}`}
                  >
                    <img
                      alt=""
                      src={active ? opt.activeIcon : opt.inactiveIcon}
                    />
                    <span
                      className={`font-semibold ${
                        active ? "text-[#333333]" : "text-[#606060]"
                      }`}
                    >
                      {opt.label}
                    </span>
                  </div>
                );
              })}
            </div>

            {/* SIZE */}
            <p className="font-semibold font-lexend text-[18px] md:text-[20px] py-3  ">
              Select your size
            </p>
            <div className="grid grid-cols-3 gap-4 ">
              {SizeOptions.map((opt) => {
                const active = tempSelected.size === opt.value;
                return (
                  <div
                    key={opt.value}
                    onClick={() =>
                      setTempSelected((prev) => ({
                        ...prev,
                        size: opt.value,
                      }))
                    }
                    className={`cursor-pointer flex flex-col md:flex-row gap-2 sm:gap-3
          items-center justify-center p-3 rounded-lg border
                    ${active ? "bg-[#deecdd]" : "border-gray-300"}`}
                  >
                    <img
                      alt=""
                      src={active ? opt.activeIcon : opt.inactiveIcon}
                    />
                    <span
                      className={`font-semibold ${active ? "text-[#333333]" : "text-[#606060]"}`}
                    >
                      {opt.label}
                    </span>
                  </div>
                );
              })}
            </div>

            {/* DIMENSIONS */}
            <p className="font-semibold font-lexend text-[18px] md:text-[20px] py-3">
              Select your dimensions
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
              {/* DIMENSION DROPDOWN */}
              <div className="relative" ref={dimensionRef}>
                <button
                  onClick={() => setCustomDropdownOpen(!customDropdownOpen)}
                  className="w-full border rounded-lg p-4 flex gap-5 xl:gap-0 justify-center md:justify-between items-center h-full"
                >
                  <span>
                    <b>{tempSelected.inch}</b>{" "}
                    <span className="font-light">{tempSelected.cm}</span>
                  </span>
                  <svg
                    className={`w-5 h-5 text-gray-600 transition-transform duration-200 ${
                      customDropdownOpen ? "rotate-180" : ""
                    }`}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>

                {customDropdownOpen && (
                  <ul className="absolute w-full bg-white border rounded-lg shadow mt-2 z-10">
                    {dimensionOptions.map((opt) => (
                      <li
                        key={opt.value}
                        onClick={() => {
                          setTempSelected((prev) => ({
                            ...prev,
                            inch: opt.labelInch,
                            cm: opt.labelCm,
                          }));
                          setCustomDropdownOpen(false);
                          setCustomSizeActive(false);
                        }}
                        className="p-3 hover:bg-gray-100 cursor-pointer"
                      >
                        <b>{opt.labelInch}</b> <span>{opt.labelCm}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* CUSTOM SIZE */}
              <div
                onClick={() => setCustomSizeActive(!customSizeActive)}
                className={`cursor-pointer flex gap-3 items-center justify-center border rounded-lg p-4
    ${customSizeActive ? "bg-[#deecdd]" : "border-gray-300"}`}
              >
                <img
                  alt=""
                  src={customSizeActive ? CustomSizeActive : CustomSizeInActive}
                />
                <span className="font-semibold">Your custom size</span>
              </div>
            </div>

            {/* MEASURE */}
            <div className="grid grid-cols-1 md:grid-cols-2  py-3">
              <div className="flex gap-2 bg-[#f4e391] border border-[#c6b484] rounded-lg py-2 justify-center items-center">
                <YouTubeIcon className="text-[#7a6f42]" />
                <span className="text-[#7a6f42]">
                  Measure the right mattress size
                </span>
              </div>
              <div></div>
            </div>
            {/* COVER */}
            <p className="font-semibold font-lexend text-[18px] md:text-[20px] pb-2">
              Select a Cover
            </p>

            <div className="relative" ref={coverRef}>
              <button
                onClick={() => {
                  setCoverDropdownOpen(!coverDropdownOpen);
                  scrollToBottom();
                }}
                className="w-full border rounded-lg p-4 flex justify-between items-center h-full"
              >
                <span className="flex flex-col xl:flex-row xl:items-center xl:gap-1">
                  <b>{selectedCover.label}</b>
                  <span className="font-light">
                    ({selectedCover.description})
                  </span>
                </span>

                <svg
                  className={`w-5 h-5 text-gray-600 transition-transform duration-200 ${
                    coverDropdownOpen ? "rotate-180" : ""
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {coverDropdownOpen && (
                <ul className="absolute w-full  bg-white border rounded-lg shadow mt-2 z-[500]">
                  {coverOptions.map((opt) => (
                    <li
                      key={opt.value}
                      onClick={() => {
                        setSelectedCover(opt);
                        setCoverDropdownOpen(false);
                      }}
                      className="p-3 hover:bg-gray-100 cursor-pointer"
                    >
                      <b>{opt.label}</b>{" "}
                      <span className="font-light">({opt.description})</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          {/* FOOTER */}
          <div className="bg-[#f5e59d] px-10 xl:px-28 py-4 3xl:py-8 flex justify-center md:justify-end">
            <button
              onClick={() => {
                setSelected(tempSelected); // ✅ COMMIT
                onClose();
              }}
              className="bg-[#2f5d3a] text-[#f4e391] font-lexend text-[18px] 3xl:text-[22px] px-6 rounded-lg py-2 flex items-center gap-2"
            >
              <ShoppingCartIcon
                sx={{ fontSize: 24 }}
                className="text-[#d5ecd5]"
              />
              Update the cart
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
